<template>
  <div>
    <div v-if="rootFolders.length > 0"
         class="CL__FolderDrawer">
      <v-treeview v-if="folderDrawer"
                  dense
                  activatable
                  hoverable
                  :active="activeFolders"
                  :open.sync="openFolders"
                  @update:active="updateActiveFolders"
                  :color="$root.folderTreeViewColor"
                  :items="rootFolders"
                  item-key="id"
                  item-text="name"
                  item-children="children"
                  :open-on-click="false"
                  :multiple-active="false">
        <template v-slot:prepend="{item: folder, active, open}">
          <v-icon v-if="folder.icon">
            {{ folder.icon }}
          </v-icon>
          <v-icon v-else-if="active || open">
            fas fa-fw fa-folder-open
          </v-icon>
          <v-icon v-else>
            fas fa-fw fa-folder
          </v-icon>
        </template>
        <template v-slot:label="{item: folder, leaf, selected, active, open}">
          <v-tooltip top>
            <template v-slot:activator="{on, attrs}">
            <span v-bind="attrs"
                  v-on="on">
              {{ folder.name }}
            </span>
            </template>
            <span>{{ folder.name }}</span>
          </v-tooltip>
        </template>
      </v-treeview>
    </div>
    <div v-if="folderDrawer && loadingFolders"
         class="ml-10 mr-3">
      <v-progress-linear height="30"
                         indeterminate
                         rounded
                         color="primary"
                         dark>
        <template v-slot:default>
          Loading folders
        </template>
      </v-progress-linear>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {clone, isArray, isInteger} from 'lodash';

export default {
  computed: {
    ...mapGetters('content', [
      'activeFolders',
      'folder',
      'folderDrawer',
      'loadingFolders', // MLD-7933
      'homeFolder',
      'presentations',
      'rootFolders',
    ]),
    openFolders: { // MLD-3090
      get() {
        return this.$store.state.content.openFolders
      },
      set(val) {
        this.$store.commit('content/setOpenFolders', val)
      },
    },
    folderID() { // MLD-5727
      if (this.$route.query.folder_id) {
        return parseInt(this.$route.query.folder_id);
      }
      return null;
    }
  },
  watch: {
    rootFolders: function () { // MLD-5727
      if (isInteger(this.folderID)) {
        this.updateActiveFolders([this.folderID]);
      }
    },
    folderID: function (folderID, oldFolderID) { // MLD-5727
      if (isInteger(folderID) && folderID !== oldFolderID) {
        this.updateActiveFolders([folderID]);
      }
    }
  },
  methods: {
    ...mapActions('content', [
      'toggleFolderDrawer',
    ]),
    updateActiveFolders(activeFolders) { // MLD-3090
      if (['library.home', 'mobile.home'].includes(this.$route.name)) {
        if (isArray(activeFolders) && activeFolders.length > 0 && activeFolders[0] !== this.folderID) {
          this.$router.push({name: this.$route.name, query: {folder_id: activeFolders[0]}});
        }
      }
      this.$store.dispatch('content/updateActiveFolders', activeFolders);
      if (this.folder && this.folder.children && this.folder.children.length) {
        if (!this.openFolders.includes(this.folder.id)) {
          const openFolders = clone(this.openFolders);
          openFolders.push(this.folder.id);
          this.$store.dispatch('content/updateOpenFolders', openFolders);
        }
      }
      this.$store.dispatch('content/searchPresentations');
    },
  }
}
</script>
